<template>
  <div>
      <div style="width: 100%;">
        <table
          class="table table-sm table-bordered table-chek"
        >
          <tr>
            <td class="td-one">
              <span class="data-bemor-chek">
                Пациент:
              </span>
            </td>
            <td class="td-one">
              <div class="data-bemor-chek">{{ datas.bemorId }}</div>
            </td>
            <td>
              <span class="data-bemor-chek">{{
                datas.name
              }}</span>
            </td>
            <!-- <td>
              <b class="data-bemor-chek">
                  Пациент ID
              </b>
            </td> -->
          </tr>
          <tr>
            <td colspan="2" class="td-two">
              <span class="data-bemor-chek">
                Дата рождения:
              </span>
            </td>
            <td>
              <span class="data-bemor-chek">{{ datas.birthday | moment }}</span>
              
            </td>
            <!-- <td rowspan="2">
                <div class="data-bemor-chek">{{ datas.bemorId }}</div>
            </td> -->
          </tr>
          <tr>
            <td colspan="2" class="td-two">
              <span class="data-bemor-chek">
                Дата обследования:
              </span>
            </td>
            <td>
              <span class="data-bemor-chek"> {{ date | momentDate }}</span>
              
            </td>
          </tr>
          <tr v-if="bolim">
            <td colspan="2" class="td-two">
              <span class="data-bemor-chek">
                Отдел:
              </span>
            </td>
            <td>
              <span class="data-bemor-chek"> {{ bolim }}</span>
            </td>
          </tr>
          <tr v-if="name">
            <td colspan="2" class="td-two">
              <span class="data-bemor-chek">
                Обследование:
              </span>
            </td>
            <td>
              <span class="data-bemor-chek"> {{ name }}</span>
            </td>
          </tr>
          <tr v-if="doctor_name">
            <td colspan="2" class="td-two">
              <span class="data-bemor-chek">
                Врач:
              </span>
            </td>
            <td>
              <span class="data-bemor-chek"> {{ doctor_name }}</span>
              
            </td>
          </tr>
        </table>
      </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: ["datas", "date", "name", "bolim", "doctor_name"],
  data() {
    return{
      
    }
  },
  filters: {
      moment: function(date) {
      if (date) {
          return moment.unix(date).format("DD.MM.YYYY");
      } else {
          return "";
      }
      },
      momentDate: function(date) {
      if (date) {
          let x = moment(new Date(date).getTime()).format("DD.MM.YYYY HH:mm");
          return x;
      } else {
          return "";
      }
      }
  },

}
</script>
<style>
.data-bemor-chek{
  font-size: 18pt;
  font-weight: 600;
  font-family: 'Times New Roman'
}
.table-chek td{
  padding: 0px 7px  !important;
  border: 1px solid #000 !important;
}
.td-two{
  width: 244px;
  background: #d6d5d5 !important;
}
.td-one{
  width: 110px;
  background: #d6d5d5 !important;
}
</style>